import styled, { css } from "styled-components/native";
import { View } from "react-native";
import { Theme } from "../../theming/types";

export const Container = styled(View)`
  flex-direction: row;
`;

export const ButtonGroup = styled(View)<{
  hasMaxWidth?: boolean;
  isSimpleBetButtons?: boolean;
}>`
  flex-direction: row;
  border-radius: ${({ theme }: { theme: Theme }) => theme.radii.xs};
  box-shadow: ${({ theme }: { theme: Theme }) => theme.elevations.low};
  overflow: hidden;
  ${({
    hasMaxWidth,
    isSimpleBetButtons
  }: {
    hasMaxWidth?: boolean;
    isSimpleBetButtons?: boolean;
  }) =>
    hasMaxWidth &&
    css`
      width: ${isSimpleBetButtons ? "151px" : "220px"};
    `}
`;
